import Box from '@mui/material/Box'
import { Outlet } from 'react-router-dom'
import * as React from 'react'
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material'
import HeaderTicket from './HeaderTicket'

const ticketTheme = createTheme({
  palette: {
    primary: {
      lighter: '#E2E8F0',
      light: '#94A3B8',
      main: '#475569',
      dark: '#334155',
      darker: '#1E293B',
      contrastText: '#fff',
    },
    secondary: {
      lighter: '#F1F5F9',
      light: '#CBD5E1',
      main: '#64748B',
      dark: '#475569',
      darker: '#1E293B',
      contrastText: '#fff',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1E293B',
      secondary: '#64748B',
    },
  },
  typography: {
    fontFamily: 'Public Sans, sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '0.5rem',
          fontWeight: 600,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '0.375rem',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '0.75rem',
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        },
      },
    },
  },
})

const BaseTicket = () => {
  return (
    <ThemeProvider theme={ticketTheme}>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: 'background.default' }}>
        <CssBaseline />
        <HeaderTicket />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: { xs: 2, sm: 3, md: 4 },
            py: 3,
            maxWidth: 1200,
            width: '100%',
            mx: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </ThemeProvider>
  )
}

export default BaseTicket
